import { render } from "./SelecionarCodigoEnquadramentoIpi.vue?vue&type=template&id=57b72487&ts=true"
import script from "./SelecionarCodigoEnquadramentoIpi.vue?vue&type=script&lang=ts"
export * from "./SelecionarCodigoEnquadramentoIpi.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__